export default __webpack_public_path__ + "static/media/setoran.29ff0012.png";